module.exports = __webpack_public_path__ + "static/img/20019 (2).e8ab76f.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20000/20019 (2).webp
// module id = X94t
// module chunks = 14